var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tr",
    { staticClass: "top-filter-row" },
    [
      _c("q-td"),
      _vm._l(_vm.cols, function(column) {
        return _c(
          "q-td",
          { key: column.name },
          [
            column.filterable
              ? _c(
                  "q-field",
                  [
                    _c(
                      _vm._f("filterIs")(column),
                      _vm._b(
                        {
                          tag: "component",
                          attrs: {
                            resource: _vm.resource,
                            clearable: true,
                            align: column.align,
                            "hide-underline": true,
                            value: _vm.activeFilterKeys[column.field],
                            template: "filter",
                            "is-filter": true,
                            placeholder: "All",
                            column: column
                          },
                          on: {
                            remove: function($event) {
                              return _vm.handleRemoveFilter(column)
                            },
                            apply: function($event) {
                              return _vm.applyFilter(column, $event)
                            }
                          }
                        },
                        "component",
                        column.component ? column.component.props : {},
                        false
                      )
                    )
                  ],
                  1
                )
              : _c("span")
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }